import React from "react";
import "./Company.css";
import Slider1 from "./IMG/Slider1.svg";
import Slider2 from "./IMG/Slider2.svg";
import Slider3 from "./IMG/Slider3.svg";
import Slider4 from "./IMG/Slider4.svg";
import Slider5 from "./IMG/Slider5.svg";

function Company() {
  return (
    <section aria-labelledby="company-profile-heading">
      <h2 id="company-profile-heading" className="V01plqa">Company Profile</h2>
      <div className="Bo0pq1">
        <div className="KG0174">
          <div id="slider">
            <figure>
              <img src={Slider1} alt="" />
              <img src={Slider2} alt="" />
              <img src={Slider3} alt="" />
              <img src={Slider4} alt="" />
              <img src={Slider5} alt="" />
            </figure>
          </div>
        </div>
        <div className="HDG081">
          <p className="HAa01756">
            Quarec Resources Pvt. Ltd. supports employers and jobseekers with
            recruitment and HR services. Each engagement is scoped around the
            role, required skills, location, employment terms and agreed
            recruitment process. Employers make hiring decisions, and neither a
            placement nor a job offer is guaranteed.
          </p>
          <div className="JDH0175">
            <a
              className="shiney-btn"
              href="/Quarec%20Resources-%20Company%20Profile.pdf"
              download="Quarec-Resources-Company-Profile.pdf"
            >
              Download company profile (PDF)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Company;
